"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _pricing = require("../helpers/pricing");
var ExtrasOrderItem = function ExtrasOrderItem(_ref) {
  var item = _ref.item,
    order = _ref.order;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "booking-list-row padding-sm radius-md margin-bottom-md d8-u-primary-bg-low-bg shadow-md",
    key: item.id
  }, !order.dueDate && /*#__PURE__*/_react["default"].createElement("div", {
    className: "booking-list-row-date"
  }, "(Pay on arrival)"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "booking-list-row-text"
  }, "".concat(order.profile && order.profile.firstName ? "".concat(order.profile.firstName, ":") : '', " ").concat(item.quantity, " x ").concat(item.productVariant.name, " -\n                ").concat((0, _pricing.formatCurrency)(item.grossQuantityPrice / 100, order.currency, order.currency))));
};
ExtrasOrderItem.propTypes = {
  item: _propTypes["default"].object.isRequired,
  order: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ExtrasOrderItem;